img(:src='url' ref='banner' :style='`transform: translateY(${bannerTranslateY}px);`')
